import { render, staticRenderFns } from "./heartBeat.vue?vue&type=template&id=4885d2fe&scoped=true"
import script from "./heartBeat.vue?vue&type=script&lang=js"
export * from "./heartBeat.vue?vue&type=script&lang=js"
import style0 from "./heartBeat.vue?vue&type=style&index=0&id=4885d2fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4885d2fe",
  null
  
)

export default component.exports